import React from 'react';
import cssStyles from 'components/ui/servicePicker/toggle/ServiceToggle.module.css';
import { handleFocus } from 'utils/commonUtil';

/**
 * Custom toggle for the React Dropdown. It is needed just to have custom mark up.
 */
class ServiceToggle extends React.Component<any> {
  constructor(props: any, context: any) {
    super(props, context);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e: any) {
    e.preventDefault();
    this.props.onClick(e);
    this.props.handleFocus();
  }

  getServiceName(id: string) {
    return id.split('\\')[1];
  }
  getId(id: string) {
    return id.split('\\')[0];
  }

  componentDidMount() {
    if (this.props.focus === true && this.props.innerRef) {
      handleFocus(this.props.innerRef.current);
    }
  }

  render() {
    const { id } = this.props;
    const titleServiceName = this.getServiceName(id);
    return (
      <button
        disabled={this.props.disabled}
        type="button"
        onClick={this.handleClick}
        title={this.props.children as string}
        className={cssStyles.serviceToggle + ' form-control custom-select'}
        id={this.getId(id)}
        ref={this.props.innerRef}
      >
        <span title={titleServiceName} className={cssStyles.serviceToggleValue}>
          {this.props.children}
        </span>
      </button>
    );
  }
}

export default React.forwardRef((props, ref) => <ServiceToggle innerRef={ref} {...props} />);
